import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { MatchHeatMap, PassMatrixMatch } from '@domains/match'
import { MetricResultQuery } from '@domains/metric'
import { SpaceMetric } from '@domains/space'

@Injectable()
export class MatchDataApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchMetrics(query: MetricResultQuery): Observable<SpaceMetric[]> {
    return this._http.post<SpaceMetric[]>(environment.api.widgets.base, {
      ...query,
      includeSeasonCompetition: true,
    })
  }

  fetchPassMatrix(matchId: string): Observable<PassMatrixMatch> {
    return this._http.get<PassMatrixMatch>(environment.api.matchPassMatrix(matchId))
  }

  fetchHeatMap(query: MetricResultQuery): Observable<MatchHeatMap> {
    const { matchId, seasonId, competitionId } = query
    return this._http.get<MatchHeatMap>(
      environment.api.matchHeatmap(matchId, seasonId, competitionId),
    )
  }
}
